import React from 'react';
import { connect } from 'react-redux';
import fields, { globalFieldLengths } from '@/constants/fields';
import { splitUrl } from '@/constants/urls';
import DictionaryUriInput from '../../dictionaries/components/DictionaryUriInput';
import LookupValue from './LookupValue';
import LookupValueContainer, {
  mapDispatchToProps,
  mapStateToProps,
} from '../components/LookupValueContainer';

const LookupUri = ({
  uri,
  uriProtocol,
  uriLink,
  lookupItemUUID,
  isEditing,
  exists,
  canRead,
  updateProperties,
  saveErrors,
}) => {
  const updateLookupUriLink = (value) => {
    const parts = splitUrl(value, uriProtocol);
    updateProperties(lookupItemUUID, { isDirty: true, uri: parts });
  };

  const updateLookupUriProtocol = (value) => {
    updateProperties(lookupItemUUID, { isDirty: true, uri: { protocol: value } });
  };

  if (!isEditing) {
    return (<LookupValue value={uri} className="td-editable-name aridhia-url-link" showUrlLinks />);
  }

  const error = saveErrors.find((e) => (
    e.context.lookupItemUUID === lookupItemUUID && e.fields.includes(fields.URI)));

  return (
    <LookupValueContainer exists={exists} canRead={canRead}>
      <DictionaryUriInput
        error={error !== undefined}
        fluid
        type="lookup.item.uri"
        text={uriLink}
        protocol={uriProtocol}
        maxLength={globalFieldLengths.url}
        onChange={updateLookupUriLink}
        onProtocolChange={updateLookupUriProtocol}
      />
    </LookupValueContainer>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(LookupUri);
